import React from 'react';

import { makeUclComponent } from '@rbilabs/universal-components';

import { ILocation } from '@rbi-ctg/frontend';
import Link, { IInLineLinkProps } from 'components/link';
import { t } from 'state/intl/translations';
import { nativeMapsHref } from 'utils/native-actions';

import theme from './theme';

const DirectionsLinkStyled = Link.withConfig({
  color: theme.innerAnchorColor,
  fontWeight: 'bold',
  fontSize: 'md',
  isUnderlined: true,
});

type Props = Omit<IInLineLinkProps, 'to' | 'isInline'> & {
  activeCoordinates: ILocation | null;
  mapPosition: ILocation;
};

export const DirectionsLink = makeUclComponent(
  ({ activeCoordinates, mapPosition, ...rest }: Props) => {
    return (
      <DirectionsLinkStyled
        {...rest}
        isExternal
        isInline
        to={nativeMapsHref(activeCoordinates, mapPosition)}
      >
        {t('directions')}
      </DirectionsLinkStyled>
    );
  }
);
